import { useNavigate } from 'react-router-dom';

export default function SLFooter() {
  const navigate = useNavigate();

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800/60 py-8">
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Logo */}
        <a
          href="/"
          onClick={(e) => { e.preventDefault(); navigate('/'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center bg-orange-500 rounded-md">
            <i className="ri-rocket-2-fill text-white text-xs" />
          </div>
          <span className="text-white font-bold text-base tracking-tight">
            boost<span className="text-orange-500">io</span>
          </span>
        </a>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-5">
          {[
            { label: 'Hlavná stránka', href: '/' },
            { label: 'O nás', href: '/o-nas' },
            { label: 'Ochrana súkromia', href: '/ochrana-sukromia' },
            { label: 'Obchodné podmienky', href: '/obchodne-podmienky' },
          ].map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); navigate(link.href); }}
              className="text-zinc-500 hover:text-zinc-300 text-xs transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <p className="text-zinc-600 text-xs">
          &copy; {new Date().getFullYear()} boostio
        </p>
      </div>
    </footer>
  );
}
